import '../node_modules/bootstrap/scss/bootstrap.scss' 
import React, { useState, useEffect, useRef } from 'react';
import QRCode from 'qrcode'
import Viewer, { Worker } from '@phuocng/react-pdf-viewer';
import '@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css';
import Velocity from 'velocity-animate';




// import logo from './logo.svg';
import bg from './img/bg.png';
import productos from './img/productos.gif'
import digital from './img/digital.gif'
import footer from './img/footer_melon.jpg'

import './App.css';

import Breadcrumbs from './Breadcrumbs'
import Nav from './Nav'

import { Link } from "react-router-dom";

function App() {

  let baseURL = 'https://expo.melon.cl/huella/index.html?';

  let [showQRModal, setShowQRModal] = useState(false);
  let [showPDFModal, setShowPDFModal] = useState(false);
  let [colorCode, setColorCode] = useState('');
  let [distancia, setDistancia] = useState(0);
  let [epochId, setEpochId] = useState('');
  let [gotDistanciaTotal, setGotDistanciaTotal] = useState(false);
  
  let [comuna, setComuna] = useState('');
  let [region, setRegion] = useState('');
  let [llegadaStgo, setLlegadaStgo] = useState(0);
  let [llegadaEdifica, setLlegadaEdifica] = useState(0);
  let [distanciaSantiago, setDistanciaSantiago] = useState(0);
  let [distanciaEdifica, setDistanciaEdifica] = useState(0);
  let [distanciaTotal, setDistanciaTotal] = useState(0);
  let [huella, setHuella] = useState(0);
  let [bonos, setBonos] = useState(0);
  let [currentSlide, setCurrentSlide] = useState(0);

  const slider1 = useRef();

  const refRegiones = useRef();
  const refComunas = useRef();
  const distanciaRecorrida = useRef();
  const distanciaNumero = useRef();

var distanciasSantiago = [
    {
        "comuna": "Conchalí",
        "distancia": "10.4"
    },
    {
        "comuna": "Conchalí",
        "distancia": "9.9"
    },
    {
        "comuna": "Cerrillos",
        "distancia": "30.8"
    },
    {
        "comuna": "Cerrillos",
        "distancia": "30.4"
    },
    {
        "comuna": "Huechuraba",
        "distancia": "2.7"
    },
    {
        "comuna": "Huechuraba",
        "distancia": "3.1"
    },
    {
        "comuna": "La Cisterna",
        "distancia": "29.8"
    },
    {
        "comuna": "La Cisterna",
        "distancia": "29.3"
    },
    {
        "comuna": "Cerro Navia",
        "distancia": "24.9"
    },
    {
        "comuna": "Cerro Navia",
        "distancia": "24.4"
    },
    {
        "comuna": "El Bosque",
        "distancia": "34.0"
    },
    {
        "comuna": "El Bosque",
        "distancia": "33.5"
    },
    {
        "comuna": "Independencia",
        "distancia": "7.1"
    },
    {
        "comuna": "Independencia",
        "distancia": "15.7"
    },
    {
        "comuna": "La Pintana",
        "distancia": "30.2"
    },
    {
        "comuna": "La Pintana",
        "distancia": "30.4"
    },
    {
        "comuna": "Ñuñoa",
        "distancia": "9.7"
    },
    {
        "comuna": "Ñuñoa",
        "distancia": "9.9"
    },
    {
        "comuna": "Peñalolén",
        "distancia": "15.6"
    },
    {
        "comuna": "Peñalolén",
        "distancia": "15.8"
    },
    {
        "comuna": "Las Condes",
        "distancia": "13.8"
    },
    {
        "comuna": "Las Condes",
        "distancia": "14.0"
    },
    {
        "comuna": "Quilicura",
        "distancia": "13.1"
    },
    {
        "comuna": "Quilicura",
        "distancia": "12.6"
    },
    {
        "comuna": "Lo Barnechea",
        "distancia": "14.9"
    },
    {
        "comuna": "Lo Barnechea",
        "distancia": "15.1"
    },
    {
        "comuna": "Lo Espejo",
        "distancia": "28.6"
    },
    {
        "comuna": "Lo Espejo",
        "distancia": "28.1"
    },
    {
        "comuna": "Pudahuel",
        "distancia": "24.6"
    },
    {
        "comuna": "Pudahuel",
        "distancia": "24.1"
    },
    {
        "comuna": "La Florida",
        "distancia": "20.9"
    },
    {
        "comuna": "La Florida",
        "distancia": "21.1"
    },
    {
        "comuna": "Renca",
        "distancia": "18.3"
    },
    {
        "comuna": "Renca",
        "distancia": "18.5"
    },
    {
        "comuna": "Maipú",
        "distancia": "32.3"
    },
    {
        "comuna": "Maipú",
        "distancia": "31.8"
    },
    {
        "comuna": "Providencia",
        "distancia": "7.4"
    },
    {
        "comuna": "Providencia",
        "distancia": "7.6"
    },
    {
        "comuna": "Pirque",
        "distancia": "56.6"
    },
    {
        "comuna": "Pirque",
        "distancia": "56.1"
    },
    {
        "comuna": "Vitacura",
        "distancia": "7.7"
    },
    {
        "comuna": "Vitacura",
        "distancia": "7.9"
    },
    {
        "comuna": "Talagante",
        "distancia": "61.4"
    },
    {
        "comuna": "Talagante",
        "distancia": "60.9"
    },
    {
        "comuna": "Estación Central",
        "distancia": "21.9"
    },
    {
        "comuna": "Estación Central",
        "distancia": "21.4"
    },
    {
        "comuna": "Melipilla",
        "distancia": "89.5"
    },
    {
        "comuna": "Melipilla",
        "distancia": "89.0"
    },
    {
        "comuna": "Recoleta",
        "distancia": "3.0"
    },
    {
        "comuna": "Recoleta",
        "distancia": "3.8"
    },
    {
        "comuna": "Peñaflor",
        "distancia": "51.5"
    },
    {
        "comuna": "Peñaflor",
        "distancia": "51.0"
    },
    {
        "comuna": "Calera de Tango",
        "distancia": "45.0"
    },
    {
        "comuna": "Calera de Tango",
        "distancia": "44.5"
    },
    {
        "comuna": "La Granja",
        "distancia": "23.7"
    },
    {
        "comuna": "La Granja",
        "distancia": "23.9"
    },
    {
        "comuna": "La Reina",
        "distancia": "14.7"
    },
    {
        "comuna": "La Reina",
        "distancia": "14.9"
    },
    {
        "comuna": "Quinta Normal",
        "distancia": "17.2"
    },
    {
        "comuna": "Quinta Normal",
        "distancia": "16.7"
    },
    {
        "comuna": "Isla de Maipo",
        "distancia": "69.2"
    },
    {
        "comuna": "Isla de Maipo",
        "distancia": "68.7"
    },
    {
        "comuna": "San Bernardo",
        "distancia": "36.5"
    },
    {
        "comuna": "San Bernardo",
        "distancia": "36.0"
    },
    {
        "comuna": "Puente Alto",
        "distancia": "33.4"
    },
    {
        "comuna": "Puente Alto",
        "distancia": "33.6"
    },
    {
        "comuna": "María Pinto",
        "distancia": "66.6"
    },
    {
        "comuna": "María Pinto",
        "distancia": "66.2"
    },
    {
        "comuna": "Lo Prado",
        "distancia": "20.6"
    },
    {
        "comuna": "Lo Prado",
        "distancia": "20.1"
    },
    {
        "comuna": "Pedro Aguirre Cerda",
        "distancia": "24.4"
    },
    {
        "comuna": "Pedro Aguirre Cerda",
        "distancia": "23.9"
    },
    {
        "comuna": "San Joaquín",
        "distancia": "30.3"
    },
    {
        "comuna": "San Joaquín",
        "distancia": "29.8"
    },
    {
        "comuna": "San Miguel",
        "distancia": "25.8"
    },
    {
        "comuna": "San Miguel",
        "distancia": "25.3"
    },
    {
        "comuna": "San Ramón",
        "distancia": "34.0"
    },
    {
        "comuna": "San Ramón",
        "distancia": "33.5"
    },
    {
        "comuna": "Padre Hurtado",
        "distancia": "45.6"
    },
    {
        "comuna": "Padre Hurtado",
        "distancia": "45.1"
    },
    {
        "comuna": "San José de Maipo",
        "distancia": "54.0"
    },
    {
        "comuna": "San José de Maipo",
        "distancia": "54.2"
    },
    {
        "comuna": "Santiago",
        "distancia": "14"
    },    
    {
        "comuna": "Macul",
        "distancia": "13.0"
    },
    {
        "comuna": "Macul",
        "distancia": "13.2"
    },
    {
        "comuna": "Curacaví",
        "distancia": "23.8"
    },
    {
        "comuna": "Curacaví",
        "distancia": "23.3"
    },
    {
        "comuna": "Tiltil",
        "distancia": "14.0"
    },
    {
        "comuna": "Tiltil",
        "distancia": "14.2"
    },
    {
        "comuna": "Colina",
        "distancia": "27.7"
    },
    {
        "comuna": "Colina",
        "distancia": "27.2"
    },
    {
        "comuna": "Paine",
        "distancia": "5.9"
    },
    {
        "comuna": "Paine",
        "distancia": "5.4"
    },
    {
        "comuna": "Buin",
        "distancia": "33.3"
    },
    {
        "comuna": "Buin",
        "distancia": "32.8"
    },
    {
        "comuna": "Alhué",
        "distancia": "26.9"
    },
    {
        "comuna": "Alhué",
        "distancia": "26.4"
    },
    {
        "comuna": "El Monte",
        "distancia": "4.5"
    },
    {
        "comuna": "El Monte",
        "distancia": "5.7"
    },
    {
        "comuna": "San Pedro",
        "distancia": "25.4"
    },
    {
        "comuna": "San Pedro",
        "distancia": "25.6"
    },
    {
        "comuna": "Lampa",
        "distancia": "31.4"
    },
    {
        "comuna": "Lampa",
        "distancia": "30.9"
    }
]  

// Santiago, Santiago Metropolitan Region, Chile is not reachable by land from Los Lagos, Chile
// Santiago, Santiago Metropolitan Region, Chile is not reachable by land from Guaitecas, Aysén, Chile
// Santiago, Santiago Metropolitan Region, Chile is not reachable by land from Río Verde, Magallanes y la Antártica Chilena, Chile
// Santiago, Santiago Metropolitan Region, Chile is not reachable by land from Juan Fernández Islands, Valparaíso, Chile
// Santiago, Santiago Metropolitan Region, Chile is not reachable by land from Timaukel, Magallanes y la Antártica Chilena, Chile
// Santiago, Santiago Metropolitan Region, Chile is not reachable by land from Aysén, Chile
// Santiago, Santiago Metropolitan Region, Chile is not reachable by land from Navarino Island, Cabo de Hornos, Magallanes and Chilean Antarctica, Chile
// Santiago, Santiago Metropolitan Region, Chile is not reachable by land from Easter Island, Valparaíso, Chile

//Los Lagos, 1,111
//Isla de Pascua, 3,756
//Guaitecas, 1,191
//Río Verde, 2158
//Juan Fernández, 761
//Timaukel, 3,144
//Aysen, 2,277
//Cabo de Hornos (Ex Navarino), 3558


var distanciasRegiones = [
    {
        "comuna": "Cabo de Hornos (Ex Navarino)",
        "distancia": "3,558"
    },    
    {
        "comuna": "Aysen",
        "distancia": "2,277"
    },    
    {
        "comuna": "Timaukel",
        "distancia": "3,144"
    },       
    {
        "comuna": "Guaitecas",
        "distancia": "1,191"
    },
    {
        "comuna": "Río Verde",
        "distancia": "2,158"
    },        
    {
        "comuna": "Isla de Pascua",
        "distancia": "3,756"
    },    
    {
        "comuna": "Juan Fernández",
        "distancia": "761"
    },    
    {
        "comuna": "Los Lagos",
        "distancia": "1,111"
    },    
    {
        "comuna": "Hijuelas",
        "distancia": "108"
    },
    {
        "comuna": "Rinconada",
        "distancia": "77.1"
    },
    {
        "comuna": "Calera",
        "distancia": "115"
    },
    {
        "comuna": "Cabildo",
        "distancia": "173"
    },
    {
        "comuna": "Quintero",
        "distancia": "162"
    },
    {
        "comuna": "Algarrobo",
        "distancia": "104"
    },
    {
        "comuna": "Olmué",
        "distancia": "104"
    },
    {
        "comuna": "El Quisco",
        "distancia": "108"
    },
    {
        "comuna": "Coquimbo",
        "distancia": "462"
    },
    {
        "comuna": "Mostazal",
        "distancia": "66.3"
    },
    {
        "comuna": "Las Cabras",
        "distancia": "152"
    },
    {
        "comuna": "Litueche",
        "distancia": "146"
    },
    {
        "comuna": "Olivar",
        "distancia": "105"
    },
    {
        "comuna": "La Serena",
        "distancia": "472"
    },
    {
        "comuna": "Pichidegua",
        "distancia": "167"
    },
    {
        "comuna": "Chépica",
        "distancia": "179"
    },
    {
        "comuna": "Pencahue",
        "distancia": "273"
    },
    {
        "comuna": "Teno",
        "distancia": "182"
    },
    {
        "comuna": "Punitaqui",
        "distancia": "411"
    },
    {
        "comuna": "Molina",
        "distancia": "213"
    },
    {
        "comuna": "Vichuquén",
        "distancia": "294"
    },
    {
        "comuna": "Cauquenes",
        "distancia": "359"
    },
    {
        "comuna": "ConsVtución",
        "distancia": "297"
    },
    {
        "comuna": "Requínoa",
        "distancia": "104"
    },
    {
        "comuna": "Colbún",
        "distancia": "311"
    },
    {
        "comuna": "Taltal",
        "distancia": "1,109"
    },
    {
        "comuna": "Mejillones",
        "distancia": "1,408"
    },
    {
        "comuna": "Calama",
        "distancia": "1,535"
    },
    {
        "comuna": "San Javier",
        "distancia": "278"
    },
    {
        "comuna": "María Elena",
        "distancia": "1,524"
    },
    {
        "comuna": "Sierra Gorda",
        "distancia": "1,465"
    },
    {
        "comuna": "Alto Hospicio",
        "distancia": "1,767"
    },
    {
        "comuna": "Linares",
        "distancia": "308"
    },
    {
        "comuna": "Hualqui",
        "distancia": "526"
    },
    {
        "comuna": "Pica",
        "distancia": "1,760"
    },
    {
        "comuna": "Penco",
        "distancia": "494"
    },
    {
        "comuna": "Laja",
        "distancia": "515"
    },
    {
        "comuna": "Arica",
        "distancia": "2,036"
    },
    {
        "comuna": "Cabrero",
        "distancia": "466"
    },
    {
        "comuna": "Camiña",
        "distancia": "1,919"
    },
    {
        "comuna": "Cobquecura",
        "distancia": "439"
    },
    {
        "comuna": "Camarones",
        "distancia": "1,978"
    },
    {
        "comuna": "Talcahuano",
        "distancia": "505"
    },
    {
        "comuna": "Coihueco",
        "distancia": "427"
    },
    {
        "comuna": "Pinto",
        "distancia": "434"
    },
    {
        "comuna": "Tomé",
        "distancia": "510"
    },
    {
        "comuna": "Contulmo",
        "distancia": "638"
    },
    {
        "comuna": "San Rosendo",
        "distancia": "514"
    },
    {
        "comuna": "Quirihue",
        "distancia": "407"
    },
    {
        "comuna": "Romeral",
        "distancia": "192"
    },
    {
        "comuna": "Ninhue",
        "distancia": "432"
    },
    {
        "comuna": "Los Ángeles",
        "distancia": "516"
    },
    {
        "comuna": "Iquique",
        "distancia": "1,758"
    },
    {
        "comuna": "San Ignacio",
        "distancia": "438"
    },
    {
        "comuna": "San Carlos",
        "distancia": "382"
    },
    {
        "comuna": "Nacimiento",
        "distancia": "546"
    },
    {
        "comuna": "Treguaco",
        "distancia": "430"
    },
    {
        "comuna": "Arauco",
        "distancia": "573"
    },
    {
        "comuna": "Florida",
        "distancia": "471"
    },
    {
        "comuna": "Ñiquén",
        "distancia": "403"
    },
    {
        "comuna": "Mulchén",
        "distancia": "548"
    },
    {
        "comuna": "Putre",
        "distancia": "2,176"
    },
    {
        "comuna": "Los Álamos",
        "distancia": "619"
    },
    {
        "comuna": "Ránquil",
        "distancia": "458"
    },
    {
        "comuna": "O’Higgins",
        "distancia": "143"
    },
    {
        "comuna": "Pozo Almonte",
        "distancia": "1,769"
    },
    {
        "comuna": "San Fabián",
        "distancia": "412"
    },
    {
        "comuna": "Yungay",
        "distancia": "496"
    },
    {
        "comuna": "Nueva Imperial",
        "distancia": "715"
    },
    {
        "comuna": "Lanco",
        "distancia": "780"
    },
    {
        "comuna": "Collipulli",
        "distancia": "583"
    },
    {
        "comuna": "Angol",
        "distancia": "570"
    },
    {
        "comuna": "Teodoro Schmidt",
        "distancia": "753"
    },
    {
        "comuna": "Mariquina",
        "distancia": "804"
    },
    {
        "comuna": "Villarrica",
        "distancia": "761"
    },
    {
        "comuna": "Colchane",
        "distancia": "1,963"
    },
    {
        "comuna": "Negrete",
        "distancia": "544"
    },
    {
        "comuna": "Curacautín",
        "distancia": "674"
    },
    {
        "comuna": "Lonquimay",
        "distancia": "738"
    },
    {
        "comuna": "Gorbea",
        "distancia": "726"
    },
    {
        "comuna": "Panguipulli",
        "distancia": "827"
    },
    {
        "comuna": "Cholchol",
        "distancia": "695"
    },
    {
        "comuna": "Loncoche",
        "distancia": "763"
    },
    {
        "comuna": "Curarrehue",
        "distancia": "822"
    },
    {
        "comuna": "Victoria",
        "distancia": "617"
    },
    {
        "comuna": "Río Bueno",
        "distancia": "901"
    },
    {
        "comuna": "Corral",
        "distancia": "911"
    },
    {
        "comuna": "Máfil",
        "distancia": "814"
    },
    {
        "comuna": "Paillaco",
        "distancia": "873"
    },
    {
        "comuna": "La Unión",
        "distancia": "906"
    },
    {
        "comuna": "Quillón",
        "distancia": "448"
    },
    {
        "comuna": "Valdivia",
        "distancia": "850"
    },
    {
        "comuna": "FruVllar",
        "distancia": "992"
    },
    {
        "comuna": "Puerto Varas",
        "distancia": "1,017"
    },
    {
        "comuna": "Puerto Montt",
        "distancia": "1,034"
    },
    {
        "comuna": "Osorno",
        "distancia": "931"
    },
    {
        "comuna": "Cochamó",
        "distancia": "1,069"
    },
    {
        "comuna": "San Juan de la Costa",
        "distancia": "963"
    },
    {
        "comuna": "Puqueldón",
        "distancia": "1,237"
    },
    {
        "comuna": "Chonchi",
        "distancia": "1,222"
    },
    {
        "comuna": "Chaitén",
        "distancia": "1,273"
    },
    {
        "comuna": "Río Ibáñez",
        "distancia": "1,795"
    },
    {
        "comuna": "Quilaco",
        "distancia": "555"
    },
    {
        "comuna": "Ercilla",
        "distancia": "596"
    },
    {
        "comuna": "Tortel",
        "distancia": "2,133"
    },
    {
        "comuna": "Punta Arenas",
        "distancia": "2,993"
    },
    {
        "comuna": "Temuco",
        "distancia": "681"
    },
    {
        "comuna": "Vilcún",
        "distancia": "693"
    },
    {
        "comuna": "Maullín",
        "distancia": "1,102"
    },
    {
        "comuna": "Cochrane",
        "distancia": "2,008"
    },
    {
        "comuna": "Galvarino",
        "distancia": "671"
    },
    {
        "comuna": "Cunco",
        "distancia": "738"
    },
    {
        "comuna": "Carahue",
        "distancia": "739"
    },
    {
        "comuna": "Padre las Casas",
        "distancia": "687"
    },
    {
        "comuna": "Melipeuco",
        "distancia": "772"
    },
    {
        "comuna": "Saavedra",
        "distancia": "768"
    },
    {
        "comuna": "Los Sauces",
        "distancia": "595"
    },
    {
        "comuna": "Pitrufquén",
        "distancia": "711"
    },
    {
        "comuna": "Lautaro",
        "distancia": "654"
    },
    {
        "comuna": "Lago Ranco",
        "distancia": "923"
    },
    {
        "comuna": "San Pedro de Atacama",
        "distancia": "1,630"
    },
    {
        "comuna": "Fresia",
        "distancia": "1,022"
    },
    {
        "comuna": "Diego de Almagro",
        "distancia": "951"
    },
    {
        "comuna": "Cartagena",
        "distancia": "111"
    },
    {
        "comuna": "Freire",
        "distancia": "709"
    },
    {
        "comuna": "Pucón",
        "distancia": "786"
    },
    {
        "comuna": "Chañaral",
        "distancia": "963"
    },
    {
        "comuna": "Purén",
        "distancia": "619"
    },
    {
        "comuna": "Renaico",
        "distancia": "549"
    },
    {
        "comuna": "Los Muermos",
        "distancia": "1,056"
    },
    {
        "comuna": "AntárVca",
        "distancia": "297"
    },
    {
        "comuna": "Paredones",
        "distancia": "244"
    },
    {
        "comuna": "Panquehue",
        "distancia": "108"
    },
    {
        "comuna": "Lumaco",
        "distancia": "618"
    },
    {
        "comuna": "Toltén",
        "distancia": "778"
    },
    {
        "comuna": "Calbuco",
        "distancia": "1,083"
    },
    {
        "comuna": "Huara",
        "distancia": "1,803"
    },
    {
        "comuna": "Copiapó",
        "distancia": "808"
    },
    {
        "comuna": "Quellón",
        "distancia": "1,285"
    },
    {
        "comuna": "Llanquihue",
        "distancia": "1,009"
    },
    {
        "comuna": "Puyehue",
        "distancia": "828"
    },
    {
        "comuna": "Futrono",
        "distancia": "894"
    },
    {
        "comuna": "Purranque",
        "distancia": "969"
    },
    {
        "comuna": "San Pablo",
        "distancia": "909"
    },
    {
        "comuna": "Lago Verde",
        "distancia": "1,486"
    },
    {
        "comuna": "Ancud",
        "distancia": "1,125"
    },
    {
        "comuna": "Dalcahue",
        "distancia": "1,188"
    },
    {
        "comuna": "Queilén",
        "distancia": "1,263"
    },
    {
        "comuna": "Curaco de Vélez",
        "distancia": "1,197"
    },
    {
        "comuna": "Quemchi",
        "distancia": "1,143"
    },
    {
        "comuna": "Río Negro",
        "distancia": "962"
    },
    {
        "comuna": "Hualaihué",
        "distancia": "1,124"
    },
    {
        "comuna": "Puerto Octay",
        "distancia": "980"
    },
    {
        "comuna": "General Lagos",
        "distancia": "2,194"
    },
    {
        "comuna": "Quinchao",
        "distancia": "1,219"
    },
    {
        "comuna": "Futaleufú",
        "distancia": "1,424"
    },
    {
        "comuna": "Chile Chico",
        "distancia": "2,010"
    },
    {
        "comuna": "Porvenir",
        "distancia": "2,990"
    },
    {
        "comuna": "Castro",
        "distancia": "1,201"
    },
    {
        "comuna": "Palena",
        "distancia": "1,419"
    },
    {
        "comuna": "Cisnes",
        "distancia": "1,547"
    },
    {
        "comuna": "San Gregorio",
        "distancia": "2,828"
    },
    {
        "comuna": "Coihaique",
        "distancia": "1,679"
    },
    {
        "comuna": "Primavera",
        "distancia": "2,900"
    },
    {
        "comuna": "Chanco",
        "distancia": "429"
    },
    {
        "comuna": "Combarbalá",
        "distancia": "353"
    },
    {
        "comuna": "Casablanca",
        "distancia": "77.8"
    },
    {
        "comuna": "Natales",
        "distancia": "2,777"
    },
    {
        "comuna": "Laguna Blanca",
        "distancia": "3,020"
    },
    {
        "comuna": "Los Vilos",
        "distancia": "225"
    },
    {
        "comuna": "Salamanca",
        "distancia": "303"
    },
    {
        "comuna": "Valparaíso",
        "distancia": "116"
    },
    {
        "comuna": "Los Andes",
        "distancia": "80.2"
    },
    {
        "comuna": "Torres del Paine",
        "distancia": "2,719"
    },
    {
        "comuna": "Alto del Carmen",
        "distancia": "708"
    },
    {
        "comuna": "Caldera",
        "distancia": "874"
    },
    {
        "comuna": "Freirina",
        "distancia": "692"
    },
    {
        "comuna": "Concón",
        "distancia": "137"
    },
    {
        "comuna": "Illapel",
        "distancia": "283"
    },
    {
        "comuna": "San Esteban",
        "distancia": "84.2"
    },
    {
        "comuna": "San Pedro de la Paz",
        "distancia": "509"
    },
    {
        "comuna": "Paiguano",
        "distancia": "559"
    },
    {
        "comuna": "Zapallar",
        "distancia": "167"
    },
    {
        "comuna": "Vicuña",
        "distancia": "536"
    },
    {
        "comuna": "Calle Larga",
        "distancia": "76.2"
    },
    {
        "comuna": "Ovalle",
        "distancia": "405"
    },
    {
        "comuna": "Puchuncaví",
        "distancia": "145"
    },
    {
        "comuna": "Nogales",
        "distancia": "117"
    },
    {
        "comuna": "Huasco",
        "distancia": "707"
    },
    {
        "comuna": "Viña del Mar",
        "distancia": "122"
    },
    {
        "comuna": "Antofagasta",
        "distancia": "1,336"
    },
    {
        "comuna": "La Higuera",
        "distancia": "532"
    },
    {
        "comuna": "Río Hurtado",
        "distancia": "484"
    },
    {
        "comuna": "Ollagüe",
        "distancia": "1,732"
    },
    {
        "comuna": "Villa Alemana",
        "distancia": "115"
    },
    {
        "comuna": "San Felipe",
        "distancia": "88.6"
    },
    {
        "comuna": "La Cruz",
        "distancia": "117"
    },
    {
        "comuna": "Limache",
        "distancia": "126"
    },
    {
        "comuna": "Peumo",
        "distancia": "152"
    },
    {
        "comuna": "Quilpué",
        "distancia": "118"
    },
    {
        "comuna": "Santo Domingo",
        "distancia": "114"
    },
    {
        "comuna": "Doñihue",
        "distancia": "110"
    },
    {
        "comuna": "San Antonio",
        "distancia": "114"
    },
    {
        "comuna": "Coinco",
        "distancia": "114"
    },
    {
        "comuna": "El Tabo",
        "distancia": "113"
    },
    {
        "comuna": "Andacollo",
        "distancia": "486"
    },
    {
        "comuna": "Codegua",
        "distancia": "75.6"
    },
    {
        "comuna": "Graneros",
        "distancia": "77.9"
    },
    {
        "comuna": "Llaillay",
        "distancia": "88.7"
    },
    {
        "comuna": "Traiguén",
        "distancia": "649"
    },
    {
        "comuna": "San Fernando",
        "distancia": "141"
    },
    {
        "comuna": "Santa María",
        "distancia": "93.1"
    },
    {
        "comuna": "Navidad",
        "distancia": "154"
    },
    {
        "comuna": "Coltauco",
        "distancia": "123"
    },
    {
        "comuna": "Putaendo",
        "distancia": "103"
    },
    {
        "comuna": "La Estrella",
        "distancia": "154"
    },
    {
        "comuna": "Machalí",
        "distancia": "94.4"
    },
    {
        "comuna": "Perquenco",
        "distancia": "640"
    },
    {
        "comuna": "Papudo",
        "distancia": "169"
    },
    {
        "comuna": "Tierra Amarilla",
        "distancia": "810"
    },
    {
        "comuna": "Placilla",
        "distancia": "158"
    },
    {
        "comuna": "Pichilemu",
        "distancia": "207"
    },
    {
        "comuna": "Catemu",
        "distancia": "73.1"
    },
    {
        "comuna": "Rengo",
        "distancia": "118"
    },
    {
        "comuna": "Petorca",
        "distancia": "206"
    },
    {
        "comuna": "San Vicente",
        "distancia": "144"
    },
    {
        "comuna": "Quillota",
        "distancia": "125"
    },
    {
        "comuna": "Vallenar",
        "distancia": "666"
    },
    {
        "comuna": "Monte Patria",
        "distancia": "437"
    },
    {
        "comuna": "La Ligua",
        "distancia": "153"
    },
    {
        "comuna": "Peralillo",
        "distancia": "202"
    },
    {
        "comuna": "Tocopilla",
        "distancia": "1,529"
    },
    {
        "comuna": "Canela",
        "distancia": "302"
    },
    {
        "comuna": "Lolol",
        "distancia": "215"
    },
    {
        "comuna": "Malloa",
        "distancia": "126"
    },
    {
        "comuna": "San Rafael",
        "distancia": "238"
    },
    {
        "comuna": "Talca",
        "distancia": "257"
    },
    {
        "comuna": "Pumanque",
        "distancia": "224"
    },
    {
        "comuna": "Palmilla",
        "distancia": "184"
    },
    {
        "comuna": "Rauco",
        "distancia": "201"
    },
    {
        "comuna": "ReVro",
        "distancia": "297"
    },
    {
        "comuna": "Hualañé",
        "distancia": "260"
    },
    {
        "comuna": "Curicó",
        "distancia": "196"
    },
    {
        "comuna": "Rancagua",
        "distancia": "88.5"
    },
    {
        "comuna": "Licantén",
        "distancia": "278"
    },
    {
        "comuna": "Santa Juana",
        "distancia": "557"
    },
    {
        "comuna": "Quinta de Tilcoco",
        "distancia": "125"
    },
    {
        "comuna": "Longaví",
        "distancia": "320"
    },
    {
        "comuna": "Concepción",
        "distancia": "502"
    },
    {
        "comuna": "Pelluhue",
        "distancia": "394"
    },
    {
        "comuna": "Yerbas Buenas",
        "distancia": "304"
    },
    {
        "comuna": "Santa Cruz",
        "distancia": "182"
    },
    {
        "comuna": "Marchihue",
        "distancia": "181"
    },
    {
        "comuna": "Nancagua",
        "distancia": "166"
    },
    {
        "comuna": "Chiguayante",
        "distancia": "519"
    },
    {
        "comuna": "Maule",
        "distancia": "269"
    },
    {
        "comuna": "San Clemente",
        "distancia": "276"
    },
    {
        "comuna": "Pelarco",
        "distancia": "255"
    },
    {
        "comuna": "San Nicolás",
        "distancia": "410"
    },
    {
        "comuna": "Hualpén",
        "distancia": "507"
    },
    {
        "comuna": "El Carmen",
        "distancia": "451"
    },
    {
        "comuna": "Pemuco",
        "distancia": "476"
    },
    {
        "comuna": "Chillán Viejo",
        "distancia": "413"
    },
    {
        "comuna": "Chillán",
        "distancia": "406"
    },
    {
        "comuna": "Portezuelo",
        "distancia": "438"
    },
    {
        "comuna": "Coelemu",
        "distancia": "439"
    },
    {
        "comuna": "Empedrado",
        "distancia": "357"
    },
    {
        "comuna": "Quilleco",
        "distancia": "538"
    },
    {
        "comuna": "Cañete",
        "distancia": "637"
    },
    {
        "comuna": "Yumbel",
        "distancia": "493"
    },
    {
        "comuna": "Sagrada Familia",
        "distancia": "215"
    },
    {
        "comuna": "Lebu",
        "distancia": "636"
    },
    {
        "comuna": "Tucapel",
        "distancia": "513"
    },
    {
        "comuna": "Curepto",
        "distancia": "300"
    },
    {
        "comuna": "Antuco",
        "distancia": "560"
    },
    {
        "comuna": "Bulnes",
        "distancia": "434"
    },
    {
        "comuna": "Chimbarongo",
        "distancia": "158"
    },
    {
        "comuna": "Villa Alegre",
        "distancia": "291"
    },
    {
        "comuna": "Río Claro",
        "distancia": "243"
    },
    {
        "comuna": "Tirúa",
        "distancia": "723"
    },
    {
        "comuna": "Parral",
        "distancia": "345"
    },
    {
        "comuna": "Alto Biobío",
        "distancia": "600"
    },
    {
        "comuna": "Coronel",
        "distancia": "534"
    },
    {
        "comuna": "Lota",
        "distancia": "541"
    },
    {
        "comuna": "Santa Bárbara",
        "distancia": "551"
    },
    {
        "comuna": "Curanilahue",
        "distancia": "596"
    },
    {
        "comuna": "Frutillar",
        "distancia": "991"
    },    
]

var regionesYcomunas = {

    "regiones": [{
        "NombreRegion": "Arica y Parinacota",
        "comunas": ["Arica", "Camarones", "Putre", "General Lagos"]
    },
      {
        "NombreRegion": "Tarapacá",
        "comunas": ["Iquique", "Alto Hospicio", "Pozo Almonte", "Camiña", "Colchane", "Huara", "Pica"]
    },
      {
        "NombreRegion": "Antofagasta",
        "comunas": ["Antofagasta", "Mejillones", "Sierra Gorda", "Taltal", "Calama", "Ollagüe", "San Pedro de Atacama", "Tocopilla", "María Elena"]
    },
      {
        "NombreRegion": "Atacama",
        "comunas": ["Copiapó", "Caldera", "Tierra Amarilla", "Chañaral", "Diego de Almagro", "Vallenar", "Alto del Carmen", "Freirina", "Huasco"]
    },
      {
        "NombreRegion": "Coquimbo",
        "comunas": ["La Serena", "Coquimbo", "Andacollo", "La Higuera", "Paiguano", "Vicuña", "Illapel", "Canela", "Los Vilos", "Salamanca", "Ovalle", "Combarbalá", "Monte Patria", "Punitaqui", "Río Hurtado"]
    },
      {
        "NombreRegion": "Valparaíso",
        "comunas": ["Valparaíso", "Casablanca", "Concón", "Juan Fernández", "Puchuncaví", "Quintero", "Viña del Mar", "Isla de Pascua", "Los Andes", "Calle Larga", "Rinconada", "San Esteban", "La Ligua", "Cabildo", "Papudo", "Petorca", "Zapallar", "Quillota", "Calera", "Hijuelas", "La Cruz", "Nogales", "San Antonio", "Algarrobo", "Cartagena", "El Quisco", "El Tabo", "Santo Domingo", "San Felipe", "Catemu", "Llaillay", "Panquehue", "Putaendo", "Santa María", "Quilpué", "Limache", "Olmué", "Villa Alemana"]
    },
      {
        "NombreRegion": "del Libertador Gral. Bernardo O’Higgins",
        "comunas": ["Rancagua", "Codegua", "Coinco", "Coltauco", "Doñihue", "Graneros", "Las Cabras", "Machalí", "Malloa", "Mostazal", "Olivar", "Peumo", "Pichidegua", "Quinta de Tilcoco", "Rengo", "Requínoa", "San Vicente", "Pichilemu", "La Estrella", "Litueche", "Marchihue", "Navidad", "Paredones", "San Fernando", "Chépica", "Chimbarongo", "Lolol", "Nancagua", "Palmilla", "Peralillo", "Placilla", "Pumanque", "Santa Cruz"]
    },
      {
        "NombreRegion": "del Maule",
        "comunas": ["Talca", "ConsVtución", "Curepto", "Empedrado", "Maule", "Pelarco", "Pencahue", "Río Claro", "San Clemente", "San Rafael", "Cauquenes", "Chanco", "Pelluhue", "Curicó", "Hualañé", "Licantén", "Molina", "Rauco", "Romeral", "Sagrada Familia", "Teno", "Vichuquén", "Linares", "Colbún", "Longaví", "Parral", "ReVro", "San Javier", "Villa Alegre", "Yerbas Buenas"]
    },
      {
        "NombreRegion": "del Biobío",
        "comunas": ["Concepción", "Coronel", "Chiguayante", "Florida", "Hualqui", "Lota", "Penco", "San Pedro de la Paz", "Santa Juana", "Talcahuano", "Tomé", "Hualpén", "Lebu", "Arauco", "Cañete", "Contulmo", "Curanilahue", "Los Álamos", "Tirúa", "Los Ángeles", "Antuco", "Cabrero", "Laja", "Mulchén", "Nacimiento", "Negrete", "Quilaco", "Quilleco", "San Rosendo", "Santa Bárbara", "Tucapel", "Yumbel", "Alto Biobío", "Chillán", "Bulnes", "Cobquecura", "Coelemu", "Coihueco", "Chillán Viejo", "El Carmen", "Ninhue", "Ñiquén", "Pemuco", "Pinto", "Portezuelo", "Quillón", "Quirihue", "Ránquil", "San Carlos", "San Fabián", "San Ignacio", "San Nicolás", "Treguaco", "Yungay"]
    },
      {
        "NombreRegion": "de la Araucanía",
        "comunas": ["Temuco", "Carahue", "Cunco", "Curarrehue", "Freire", "Galvarino", "Gorbea", "Lautaro", "Loncoche", "Melipeuco", "Nueva Imperial", "Padre las Casas", "Perquenco", "Pitrufquén", "Pucón", "Saavedra", "Teodoro Schmidt", "Toltén", "Vilcún", "Villarrica", "Cholchol", "Angol", "Collipulli", "Curacautín", "Ercilla", "Lonquimay", "Los Sauces", "Lumaco", "Purén", "Renaico", "Traiguén", "Victoria", ]
    },
      {
        "NombreRegion": "de Los Ríos",
        "comunas": ["Valdivia", "Corral", "Lanco", "Los Lagos", "Máfil", "Mariquina", "Paillaco", "Panguipulli", "La Unión", "Futrono", "Lago Ranco", "Río Bueno"]
    },
      {
        "NombreRegion": "de Los Lagos",
        "comunas": ["Puerto Montt", "Calbuco", "Cochamó", "Fresia", "Frutillar", "Los Muermos", "Llanquihue", "Maullín", "Puerto Varas", "Castro", "Ancud", "Chonchi", "Curaco de Vélez", "Dalcahue", "Puqueldón", "Queilén", "Quellón", "Quemchi", "Quinchao", "Osorno", "Puerto Octay", "Purranque", "Puyehue", "Río Negro", "San Juan de la Costa", "San Pablo", "Chaitén", "Futaleufú", "Hualaihué", "Palena"]
    },
      {
        "NombreRegion": "Aisén del Gral. Carlos Ibáñez del Campo",
        "comunas": ["Coihaique", "Lago Verde", "Aisén", "Cisnes", "Guaitecas", "Cochrane", "O’Higgins", "Tortel", "Chile Chico", "Río Ibáñez"]
    },
      {
        "NombreRegion": "Magallanes y de la Antártica Chilena",
        "comunas": ["Punta Arenas", "Laguna Blanca", "Río Verde", "San Gregorio", "Cabo de Hornos (Ex Navarino)", "Porvenir", "Primavera", "Timaukel", "Natales", "Torres del Paine"]
    },
      {
        "NombreRegion": "Metropolitana de Santiago",
        "comunas": ["Santiago", "Cerrillos", "Cerro Navia", "Conchalí", "El Bosque", "Estación Central", "Huechuraba", "Independencia", "La Cisterna", "La Florida", "La Granja", "La Pintana", "La Reina", "Las Condes", "Lo Barnechea", "Lo Espejo", "Lo Prado", "Macul", "Maipú", "Ñuñoa", "Pedro Aguirre Cerda", "Peñalolén", "Providencia", "Pudahuel", "Quilicura", "Quinta Normal", "Recoleta", "Renca", "San Joaquín", "San Miguel", "San Ramón", "Vitacura", "Puente Alto", "Pirque", "San José de Maipo", "Colina", "Lampa", "Tiltil", "San Bernardo", "Buin", "Calera de Tango", "Paine", "Melipilla", "Alhué", "Curacaví", "María Pinto", "San Pedro", "Talagante", "El Monte", "Isla de Maipo", "Padre Hurtado", "Peñaflor"]
    }]
  }  

  const slideUp = (slider) => {

    // let index = parseInt(slider.current.attributes['data-index'].value);
    // let slides = parseInt(slider.current.attributes['data-slides'].value);    

    // if (index > 0) {
      Velocity(slider.current, {translateY: '+=756px'}, {duration: 500, complete: () => {
        setCurrentSlide(currentSlide-1)
        }
      });

      // document.querySelector('.slider1-index').innerHTML = index;
    // } else if (index==0) {
    //   Velocity(slider.current, {translateX: '0px'}, {duration: 250, complete: () => slider.current.setAttribute('data-index', 0)});
    // } 

  }

  const slideDown = (slider) => {

    // console.dir(slideDown);

    // if (currentSlide ) {
      Velocity(slider.current, {translateY: '-=756px'}, {duration: 500, complete: () => {
        // setCurrentSlide(currentSlide+1);
        setCurrentSlide(currentSlide+1)
      }});
      // document.querySelector('.slider1-index').innerHTML = index+2;
    // }
      
    // } else if (index==slides-1) {
    //   Velocity(slider.current, {translateX: '0%'}, {duration: 250, complete: () => slider.current.setAttribute('data-index', 0)});
    //   // document.querySelector('.slider1-index').innerHTML = 1;
      
    // }

  }

  useEffect(() => {

    if (currentSlide == 2) {

        // console.dir('slide2');

        setTimeout(() => {
            animateValue(distanciaNumero.current, 0, distanciaTotal, 5000);
        }, 500);

        
      // Velocity(distanciaRecorrida.current, {'opacity': 1}, {delay: 2000, duration: 250, begin: () => {
        
      // },complete: () => {
      //   setTimeout(() => {
      //     // setGotDistanciaTotal(true);
      //   }, 5000);
      // }});
    }



    if (currentSlide == 3) {
      Velocity(document.querySelector('.resultados-1'), {opacity: 1}, {duration: 1000, complete: () => {
        Velocity(document.querySelector('.resultados-3'), {opacity: 1}, {duration: 1000, delay: 500, complete: () => {
          
          // Velocity(document.querySelector('.resultados-3'), {opacity: 1}, {duration: 1000, delay: 500, complete: () => {
            
          //   }
          // }); 

          }
        });        
        }
      });
    }

  }, [currentSlide])

  useEffect(() => {

    setCurrentSlide(0);


  }, [])

  // useEffect(() => {
  //   if (region.length>0) {

  //   }
  // }, [region]);

  // useEffect(() => {

  //   if (comuna.length>0) {


  //   }
  //   // console.dir(region);
  // }, [comuna])

  useEffect(() => {
    if (region.length > 0 && comuna.length > 0) {
      if (region != "Metropolitana de Santiago") {
        setDistanciaEdifica(14);
        for (let i=0;i<distanciasRegiones.length;i++) {
          if (distanciasRegiones[i].comuna == comuna) {
            setDistanciaSantiago(Math.floor(parseFloat(String(distanciasRegiones[i].distancia).replace(',',''))));
          }
        }
      } else if (region == "Metropolitana de Santiago") {
        setDistanciaSantiago(0.1);
        setLlegadaStgo(0.1)
        for (let i=0;i<distanciasSantiago.length;i++) {
          if (distanciasSantiago[i].comuna == comuna) {
            setDistanciaEdifica(Math.floor(parseFloat(String(distanciasSantiago[i].distancia))));
          }
        }

      }
    }
  }, [region, comuna])

  useEffect(() => {
    if (distanciaSantiago > 0 && distanciaEdifica > 0) {
        // console.log(distanciaTotal);
      setDistanciaTotal(distanciaSantiago + distanciaEdifica);
    }
  }, [distanciaSantiago, distanciaEdifica]);

  useEffect(() => {
    if (llegadaStgo>0 && llegadaEdifica>0) {
        // console.dir(llegadaStgo);
        // console.dir(llegadaEdifica);
        // console.dir(distanciaSantiago);
        // console.dir(distanciaEdifica);
      setHuella(parseFloat((distanciaSantiago * llegadaStgo)+(distanciaEdifica * llegadaEdifica)).toFixed(2))
    }

  }, [llegadaStgo, llegadaEdifica])

  useEffect(() => {
    if (huella > 0) {
      setBonos(parseFloat(huella/1000).toFixed(2));
      let epochIdCalc = Math.round(Date.now() / 1000)
      setEpochId(epochIdCalc);
      QRCode.toCanvas(document.getElementById('qr-canvas'), 'https://expo.melon.cl/huella/index.html?bonos='+parseFloat(huella/1000).toFixed(2)+'&huella='+huella+'&epoch='+epochIdCalc, {width: 400}, function (error) {
        if (error) console.error(error)
      });
    } 
  }, [huella])

  const animateValue = (obj, start, end, duration) => {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      obj.innerHTML = Math.floor(progress * (end - start) + start);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  const handleRegion = (e) => {
    document.querySelector(".reg-selected")?.classList.remove("reg-selected");
    e.target.classList.add("reg-selected");
    setRegion(e.target.dataset.regionValue);
  }

  const handleLlegadaStgo = (e) => {
    document.querySelector(".lleg-selected")?.classList.remove("lleg-selected");
    e.target.classList.add("lleg-selected");
    setLlegadaStgo(parseFloat(String(e.target.dataset.llegada).replace(',','.')));
    // console.log(parseFloat(String(e.target.dataset.llegada.replace).replace(',','.')));
  }

  const handleLlegadaEdifica = (e) => {
    document.querySelector(".edif-selected")?.classList.remove("edif-selected");
    e.target.classList.add("edif-selected");
    setLlegadaEdifica(String(e.target.dataset.edifica).replace(',','.'));
    // console.log(parseFloat(String(e.target.dataset.edifica.replace).replace(',','.')));
  }    



  return (
    <div className="App container-fluid g-0 fullvh">

      <div className="row g-0">

        <img src={productos} className="bg" />

        <div className="row g-0 fullvh">

          <div className="col-1 g-0">
            <Nav />
          </div>

          <div className=" col d-flex">

            <div className="row g-0 d-flex flex-1 flex-column justify-center">

              <div className="col-12 d-flex flex-column justify-center">

                <div className="row inner-board ps-5 pt-5 pb-5">

                  <div className="col d-flex flex-column justify-center">
                  
                  <div className="d-flex flex-row pb-3">
                    <div className="d-flex flex-column justify-center">
                      <h3 className="t-54">Calcula tu Huella de Carbono con Melón</h3>
                    </div>
                  </div>

                  <div className="row">

                  <div className="col overflow-hidden calcula-slider">

                  <div ref={slider1} data-index="0" data-slides="2" className="calcula-scroller w-100">

                      <div className="slide">


                          <p className="pb-0 fs-1">¡Hola!, para comenzar, cuéntanos de dónde nos visitas:</p>

                          <div className="row pt-3 w-100">
                              {regionesYcomunas.regiones.map((rg, index) => {
                                return (<div key={index} onClick={(e) => {handleRegion(e)}} className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-4" data-region-value={rg.NombreRegion}>{rg.NombreRegion}</div>)
                              })}                           
                          </div>                        

                          <div className="row pt-5 w-100">
                            <div className="col d-flex flex-column align-items-center justify-end">
                              <button style={{'opacity': region.length > 0 ? 1 : 0}} onClick={() => {slideDown(slider1)}} className="col carbono-button t-26">Siguiente <i className="fa-sharp fa-solid fa-arrow-down" data-fa-mask="fa-solid fa-comment"></i></button>
                              {/*<button disabled={!(region.length > 0 && comuna.length > 0)} onClick={() => {slideDown(slider1)}} type="button" className="btn btn-primary btn-lg">Siguiente</button>*/}
                            </div>
                          </div>


                      </div>


                      <div className="slide">


                          <p className="pb-0 fs-1 pt-1 text-center">Ok, Región {region}, pero ¿de qué comuna específicamente?</p>

                          <div className="row pt-3 w-100">
                              {regionesYcomunas.regiones.map((rg, index) => {
                                if (region && region == rg.NombreRegion) {
                                  return rg.comunas.map( (com, index) => {
                                    return (<div key={index} onClick={(e) => {document.querySelector(".com-selected")?.classList.remove("com-selected");setComuna(e.target.dataset.value); e.target.classList.add("com-selected");}} className={(region ==! 'Metropolitana de Santiago') ? 'col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3 font-weight-bold' : 'col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-5 font-weight-bold'} data-value={com}>{com}</div>)  
                                  })
                                }
                              })}
                          </div>                          

                          <div className="row w-100 pt-3">
                            <div className="col d-flex flex-column align-items-center justify-end">
                              <button style={{'opacity': comuna? 1 : 0}} onClick={() => {slideDown(slider1)}} className="col carbono-button t-26">Siguiente <i className="fa-sharp fa-solid fa-arrow-down" data-fa-mask="fa-solid fa-comment"></i></button>
                              {/*<button disabled={!(region.length > 0 && comuna.length > 0)} onClick={() => {slideDown(slider1)}} type="button" className="btn btn-primary btn-lg">Siguiente</button>*/}
                            </div>
                          </div>


                      </div>



                      <div className="slide">

                          <div className="row w-100 d-flex justify-center align-items-center pt-3">
                            <div className="col-3 d-flex flex-column align-items-end"><i className="fa-solid fa-earth-americas t-102 icon-world"></i></div>
                            <div className="col-9 d-flex flex-column align-items-center justify-center">
                              <p ref={distanciaRecorrida}  className="fs-1 distancia-recorrida text-center"><span>Con esta información, calculamos tu <b>distancia recorrida</b> para llegar a Edifica 2024 en</span><span style={{'textDecoration': 'underline'}}className="distancia-numero ps-4 pe-4 d-inline-block" ref={distanciaNumero}></span><span>kilómetros, pero necesitamos un poco más de información para <b>calcular tu huella</b>:</span></p>
                            </div>
                          </div>

                          {region != "Metropolitana de Santiago" && (

                          <div className="row d-flex pt-3">

                            <p className="pb-0 fs-1 text-center">¿Cómo llegaste a Santiago?</p>

                            <div className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3" data-llegada="0,2097" onClick={(e) => {handleLlegadaStgo(e)}}>Auto bencina</div>
                            <div className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3" data-llegada="0,2491" onClick={(e) => {handleLlegadaStgo(e)}}>Auto diésel</div>
                            <div className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3" data-llegada="0,01" onClick={(e) => {handleLlegadaStgo(e)}}>Vehículo eléctrico</div>

                            <div className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3" data-llegada="0,0122" onClick={(e) => {handleLlegadaStgo(e)}}>Bus</div>
                            <div className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3" data-llegada="0,0537" onClick={(e) => {handleLlegadaStgo(e)}}>Metrotren</div>
                            <div className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3" data-llegada="0,2787" onClick={(e) => {handleLlegadaStgo(e)}}>Avión</div>

                          </div>)}

                          <div className="row d-flex pt-3 ps-1 pe-1 w-100">

                            <p className="pb-0 fs-1">¿Cuál fué tu medio de transporte principal para llegar a Edifica dentro de Santiago?</p>

                            <div className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3" data-edifica="0,2097" onClick={(e) => {handleLlegadaEdifica(e)}}>Auto bencina</div>
                            <div className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3" data-edifica="0,2491" onClick={(e) => {handleLlegadaEdifica(e)}}>Auto diésel</div>
                            <div className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3" data-edifica="0,001" onClick={(e) => {handleLlegadaEdifica(e)}}>Auto eléctrico</div>

                            <div className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3" data-edifica="0,2097" onClick={(e) => {handleLlegadaEdifica(e)}}>Taxi</div>
                            <div className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3" data-edifica="0,033" onClick={(e) => {handleLlegadaEdifica(e)}}>Metro</div>
                            <div className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3" data-edifica="0,0392" onClick={(e) => {handleLlegadaEdifica(e)}}>Transantiago</div>

                            <div className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3" data-edifica="0,001" onClick={(e) => {handleLlegadaEdifica(e)}}>Scooter/Bicicleta eléctrica</div>
                            <div className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3" data-edifica="0,001" onClick={(e) => {handleLlegadaEdifica(e)}}>Bicicleta</div>
                            <div className="col carbono-button pushy__btn pushy__btn--lg pushy__btn--blue fs-3" data-edifica="0,001" onClick={(e) => {handleLlegadaEdifica(e)}}>Caminando</div>

                          </div>                          

                          <div className="row pt-2 w-100">
                            <div className="col d-flex flex-column align-items-center justify-center">
                              <button style={{'opacity': ((llegadaStgo > 0 || region == "Metropolitana de Santiago") && llegadaEdifica > 0) ? 1 : 0}} onClick={() => {slideDown(slider1)}} className="col carbono-button t-26">Siguiente <i className="fa-sharp fa-solid fa-arrow-down" data-fa-mask="fa-solid fa-comment"></i></button>
                            </div>
                          </div>



                      </div>  
                      
                      <div className="slide">


                        <div className="row pt-5 w-100">
                            <div className="col-4 d-flex flex-column align-items-end"><i className="fa-solid fa-leaf t-206 icon-leaf"></i></div>
                          <div className="col-8 d-flex flex-column align-items-center justify-center flex-row">

                            <p className="pb-0 fs-1 resultados-1">La Huella de Carbono asociada a tu traslado es de <u>{huella}</u> kg de CO2 equivalente</p>
                            <p className="pb-0 fs-1 resultados-2 d-none">Se necesitan <u>{bonos}</u> bonos para compensar las emisiones del trayecto </p>
                          </div>
                        </div>

                          <div className="row pt-5 w-100">
                            <div className="col d-flex flex-column align-items-center justify-center flex-row">
                            <button onClick={() => {slideDown(slider1)}} className="col carbono-button t-26 resultados-3">Me gustaría compensar este número <i className="fa-sharp fa-solid fa-arrow-down" data-fa-mask="fa-solid fa-comment"></i></button>
                            </div>
                          </div>                        



                      </div>

                      <div className="slide">

                        <div className="row pt-5 w-100">
                            <div className="col d-flex flex-column align-items-center justify-center">
                            


                          <p className="pb-0 t-54 w-100 text-center">Construyamos juntos un futuro más sostenible. Melón compensará tu huella a través de bonos de carbono.</p>
                          <p className="pb-0 fs-1">Para recibir el certificado debes completar tus datos en el siguiente QR:</p>
                          <p>
                            <canvas id="qr-canvas" width="400" height="400"></canvas>
                          </p>
                          <img src={footer} />
                          {/*<p className="pb-0 fs-1 w-100 text-center pt-5">Melón, siempre contigo.</p>*/}
                          </div>
                          </div>



                      </div>                                                                                                              




                  </div>
                </div>
                </div>
                </div>
                <div className="col-1 d-flex d-none">
                  <div className="row d-flex flex-column g-0 h-100 align-items-center justify-center flex-column">
                    <div className="col g-0 fullvh d-flex justify-center flex-column">
                      <button onClick={() => slideUp(slider1)} className="nav-button mt-1"><i className="fa-sharp fa-solid fa-arrow-up" data-fa-mask="fa-solid fa-comment"></i></button>
                      <button onClick={() => slideDown(slider1)} className="nav-button mt-1"><i className="fa-sharp fa-solid fa-arrow-down" data-fa-mask="fa-solid fa-comment"></i></button>
                    </div>                       
                  </div>
                  
                </div>                      
              </div>                
                
              </div>
              
            </div>
            
          </div>          
          
        </div>

      </div>

    </div>
  );
}

export default App;
